import { committeesArray } from '../../models/committees.types';
import { ExamineeStatusPl } from './ExamineeList.types';

export const convertExamineesExamComitteFilter = (filter: string[]): string[] => {
  const res: string[] = [];
  for (let i = 0; i < filter.length; i++) {
    const idx = Number(filter[i]);
    const found = committeesArray.find((x) => x.id === idx);
    if (found) res.push(found.name);
  }

  return res;
};

export const convertStatusFilter = (filter: string[]): string[] => {
  const valueConversion: string[] = Object.values(ExamineeStatusPl);
  const res: string[] = [];
  for (let i = 0; i < filter.length; i++) {
    const idx = Number(filter[i]);
    if (idx > valueConversion.length) continue;
    res.push(valueConversion[idx].toString());
  }
  return res;
};
